import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;

  h3.ant-typography {
    margin-top: 24px;
  }

  h5.ant-typography {
    margin-top: 4px;
    margin-bottom: 24px;
  }
`;
